<!-- 召回通知单操作 -->
<template>
    <div>
        <el-drawer :close-on-press-escape="true" :title="dataActionBox.boxTitle" :visible.sync="dataActionBox.showStatus"
            :with-header="false" :append-to-body="true" :direction="dataActionBox.openMode" size="50%">
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="formDataList">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'"
                        :tabslist="formDataList.jurconfigform" @tabs="(val) => { showTabs = val }">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主信息 -->
                                <div v-if="scope.index == 0">
                                    <el-form label-width="120px" class="baseForm" size="mini" :model="sendDataInfo"
                                        ref="sendDataInfo">
                                        <el-row>
                                            <el-form-item :label="formOneValue.showField"
                                                v-for="(formOneValue, formOneKey) in formDataList.jurconfigform"
                                                :key="formOneKey" v-if="formOneValue.isShow == 1"
                                                :prop="formOneValue.entityField" :show-message="false"
                                                :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                                <label slot="label" :style="$common.labelStyle(formOneValue.showField)"
                                                    v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                                <el-date-picker v-if="formOneValue.entityField == 'rnmStdate'"
                                                    v-model="sendDataInfo[formOneValue.entityField]" type="date"
                                                    placeholder="选择日期" format="yyyy 年 MM 月 dd 日"
                                                    value-format="timestamp"></el-date-picker>
                                                <el-date-picker v-else-if="formOneValue.entityField == 'cpmStdate'"
                                                    v-model="sendDataInfo[formOneValue.entityField]" type="date"
                                                    placeholder="选择日期" format="yyyy 年 MM 月 dd 日"
                                                    value-format="timestamp"></el-date-picker>


                                                <!-- formatter下拉选   :automatic-dropdown="true"-->
                                                <el-select clearable size="mini"
                                                    v-else-if="formOneValue.fieldType == 'formatter'"
                                                    @visible-change="selectChange" :disabled="formOneValue.isChange == 0"
                                                    @change="$forceUpdate()"
                                                    v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                                    <el-option v-for="item in JSON.parse(
                                                        formOneValue.formatterContent
                                                    )" :key="item.key" :label="item.key" :value="item.value">
                                                    </el-option>
                                                </el-select>
                                                <el-input v-else-if="formOneValue.entityField == 'bgmId'"
                                                    v-model.trim="sendDataInfo.bgmName"
                                                    @focus="openSearch(formOneValue.searchId, 0, 'bgmId')">
                                                    <el-button @click="openSearch(formOneValue.searchId, 0, 'bgmId')"
                                                        slot="append" icon="el-icon-search"></el-button>
                                                </el-input>
                                                <df-date v-else-if="formOneValue.fieldType == 'date'" :isShowLong="false"
                                                    :isdisabled="formOneValue.isChange == 0"
                                                    v-model="sendDataInfo[formOneValue.entityField]"></df-date>
                                                <el-input v-else-if="formOneValue.entityField == 'batchno'" disabled
                                                    v-model="sendDataInfo.batchno"></el-input>
                                                <el-input v-else-if="formOneValue.entityField == 'receiver'"
                                                    v-model.trim="sendDataInfo.createrName"
                                                    @focus="openSearch(formOneValue.searchId, 0, 'receiver')">
                                                    <el-button @click="openSearch(formOneValue.searchId, 0, 'receiver')"
                                                        slot="append" icon="el-icon-search"></el-button>
                                                </el-input>
                                                <el-input v-else-if="formOneValue.entityField == 'rnmReason'"
                                                    type="textarea"
                                                    v-model="sendDataInfo[formOneValue.entityField]"></el-input>
                                                <el-input v-else-if="formOneValue.entityField == 'rnmNumber'" type="number"
                                                    :min="0"
                                                    v-model.number="sendDataInfo[formOneValue.entityField]"></el-input>
                                                <!-- 检索方案 -->
                                                <el-input v-else-if="formOneValue.fieldType == 'search'" clearable
                                                    v-model="sendDataInfo[formOneValue.entityField]"
                                                    :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                    @keyup.enter.native="
                                                        openSearch(
                                                            formOneValue.searchId,
                                                            formOneKey,
                                                            formOneValue.entityField,
                                                            formOneValue.setField
                                                        )">
                                                    <el-button @click="
                                                        openSearch(
                                                            formOneValue.searchId,
                                                            formOneKey,
                                                            formOneValue.entityField,
                                                            formOneValue.setField
                                                        )
                                                        " slot="append" icon="el-icon-search">
                                                    </el-button>
                                                </el-input>
                                                <el-input @keyup.enter.native="nextFocus(formOneKey)" v-else
                                                    :disabled="formOneValue.isChange == 0"
                                                    v-model.trim="sendDataInfo[formOneValue.entityField]"
                                                    :maxlength="$store.state.inputLength"></el-input>
                                            </el-form-item>
                                        </el-row>
                                    </el-form>
                                </div>

                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <div class="foots">
                    <el-button @click="dataActionBox.showStatus = false">取 消</el-button>
                    <el-button type="primary" @click="sendDataAction" v-if="dataActionBox.actionType == 0">保存</el-button>
                    <el-button type="primary" @click="sendDataAction" v-if="dataActionBox.actionType == 1">保存</el-button>
                </div>
            </div>
            <el-dialog :title="seTitle" v-if="DialogVisible" modal-append-to-body append-to-body :visible.sync="DialogVisible" :width="seWidth">
                <SearchScheme ref="searchScheme" :id="seId" @TranData="changeInputModel" />
            </el-dialog>
        </el-drawer>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../byComponents/SearchScheme.vue";
export default {
    name: "recallNoticeAction",
    props: [],
    //import引入的组件需要注入到对象中才能使用
    components: { SearchScheme },
    data() {
        //这里存放数据
        return {
            showTabs: '',
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增信息" || "编辑信息",
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {
                bgmId: "",
                rnmBatnumber: "",
                bgmName: "",
                rnmNumber: 0,
                cpmStdate: "",
                rnmReason: "",
                batchno: "",
                receiver: "",
                createrName: "",
                rnmReserves1: "",
                rnmReserves2: "",
                rnmReserves3: "",
                rnmReserves4: "",
                rnmReserves5: "",
                rnmReserves6: "",
                rnmStdate: "",
            },
            formDataList: {},
            DialogVisible: false,
            seTitle: "",
            seWidth: "",
            seId: 0,
            selectedDetailsIndex: 0, //选择索引
            focusIndex: 0, //检索焦点索引
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type) {
            this.focusIndex = index;
            this.DialogVisible = true;
            this.seId = sId;
            this.seType = type;
        },
        //检索带回数据
        changeInputModel(val) {
            console.log(this.seType, val);
            if (val != "" || val != undefined) {
                this.DialogVisible = false;

                if (this.seType == "bgmId") {
                    // this.sendDataInfo.batchno = val.batchno;
                    // this.sendDataInfo.bgmId = val.bgmId;
                    // this.sendDataInfo.bgmName = val.bgmName;
                    // this.sendDataInfo.prodate = val.prodate;
                    // this.sendDataInfo.expidate = val.expidate;
                    for (const key in val) {
                        if (val[key] != null && val[key] != undefined) {
                            this.sendDataInfo[key] = val[key]
                        } else {
                            this.sendDataInfo[key] = ''
                        }
                    }
                } else if (this.seType == "receiver") {
                    this.sendDataInfo.createrName = val.opmName;
                    this.sendDataInfo.receiver = val.opmId;
                }
            }
            // this.sendDataInfo.pisOrderDetail[this.seIndex].bgmName = val.bgmName
        },
        initActionBox() {
            for (let key in this.sendDataInfo) {
                this.sendDataInfo[key] = "";
            }
            this.sendDataInfo.rnmStdate = this.$moment().valueOf();
            this.dataActionBox.actionType = 0;
            this.dataActionBox.showStatus = false;
        },

        isShowData(name, value) {
            switch (name) {
                case "bgmId":
                    var dataInfo = sessionStorage.getItem("selectBusinessGoodsEntryInfo");
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo);
                        this.sendDataInfo.bgmId = dataInfo.bgmId;
                        this.sendDataInfo.bgmName = dataInfo.bgmName;
                    }

                    break;

                default:
                    this.sendDataInfo[name] = value;
            }
            this.sendDataInfo[name] = value;
        },

        openBox(cate, formData, oldData = "") {
            console.log(formData);
            this.formDataList = formData;
            this.initActionBox();
            if (cate == 0) {
                this.dataActionBox.boxTitle = "新增召回通知单信息";
                this.dataActionBox.openMode = "ltr";
                this.showTabs = "新增召回通知单"
            } else {
                this.dataActionBox.boxTitle = "编辑召回通知单信息";
                this.dataActionBox.openMode = "ltr";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                console.log(dataInfo, "编辑召回通知单");
                this.showTabs = "编辑召回通知单"
                // this.sendDataInfo = dataInfo;
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key])
                }
            }
            this.dataActionBox.actionType = cate;
            this.dataActionBox.showStatus = true;
        },

        async sendDataAction() {
            if (this.sendDataInfo.bgmId == "") {
                this.$message({
                    message: "请选择商品",
                    type: "error",
                });
                return false;
            }
            let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
            if (this.dataActionBox.actionType == 0) {
                var responseData = await this.$http.addRecallNotice(sendData);
            } else {
                var responseData = await this.$http.setRecallNotice(sendData);
            }
            if (responseData.status == 200) {
                this.initActionBox();
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                if (this.dataActionBox.actionType == 0) {
                    this.$parent.setDataPageNumber(1);
                } else {
                    this.$parent.getDataList();
                }
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() { },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.beform {
    display: flex;
    flex-wrap: wrap;
    padding-right: 20px;
}

.el-date-editor.el-input {
    width: 100%;
}
</style>